import template from './profile-selection.html';
import controller from './profile-selection.controller';
import './profile-selection.scss';

let ProfileSelectionComponent = {
  bindings: {
    profiles: '<',
    invitations: '<'
  },
  template,
  controller
};

export default ProfileSelectionComponent;



// WEBPACK FOOTER //
// ./src/app/pages/profile-selection/profile-selection.component.js